import { styled } from "@mui/material/styles";
import { Box, FormControl, TextField, Button } from "@mui/material";

export const InputBoxes = styled(Box)({
  display: "flex",
  position: "absolute",
  zIndex: 2,
  left: "50%",
  transform: "translateX(-50%)",
  top: 50,
});

export const DateBoxFormControl = styled(FormControl)(({ theme }) => ({
  minWidth: 150,
  marginLeft: theme.spacing(2),
}));

export const DateInput = styled(TextField)({
  backgroundColor: "#fff",
});

export const AutocompleteBox = styled(Box)({
  width: 300,
});

export const AutocompleteInput = styled(TextField)({
  backgroundColor: "#fff",
});

export const StyledButton = styled(Button)({
  width: 300,
});

export const ButtonLoading = styled(Box)({
  position: "absolute",
  top: "50%",
  left: "50%",
  marginTop: -12,
  marginLeft: -12,
});
